import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

// Image with an onError fallback to a placeholder (optionally captioned).
export function ProductImage({ src, imgClassName, placeholderClassName, placeholderText }) {
  const [hasError, setHasError] = useState(false);
  useEffect(() => setHasError(false), [src]);

  if (!src || hasError) {
    return <div className={placeholderClassName}>{placeholderText}</div>;
  }
  return (
    <img
      src={src}
      alt=""
      className={imgClassName}
      onError={e => {
        e.target.onerror = null;
        setHasError(true);
      }}
    />
  );
}

ProductImage.propTypes = {
  src: PropTypes.string,
  imgClassName: PropTypes.string.isRequired,
  placeholderClassName: PropTypes.string.isRequired,
  placeholderText: PropTypes.node,
};
